/*
 * Operaciones del nucleo tal como estan escritas en analisis/contratos.md.
 * Una funcion por contrato, con el mismo nombre, para que la trazabilidad entre
 * el analisis y el codigo sea directa.
 */

import { api } from './cliente.js';

// --- Sesion e identidad ------------------------------------------------------

export const consultarConfiguracionInicial = () => api.obtener('/configuracion-inicial');

export const ejecutarConfiguracionInicial = (peticion, fechaLocal) =>
  api.publicar(`/configuracion-inicial?fechaLocal=${fechaLocal}`, peticion);

export const iniciarSesion = (clave, contrasena, fechaLocal) =>
  api.publicar(`/sesion/inicio?fechaLocal=${fechaLocal}`, { clave, contrasena });

export const cerrarSesion = () => api.publicar('/sesion/cierre');

/** fechaLocal es la del DISPOSITIVO; sin ella idPeriodoActual viene nulo (D-06). */
export const obtenerContextoDeSesion = (fechaLocal) =>
  api.obtener(`/sesion${fechaLocal ? `?fechaLocal=${fechaLocal}` : ''}`);

// --- Monedas -----------------------------------------------------------------

export const consultarMonedas = (soloActivas = true) =>
  api.obtener(`/monedas?soloActivas=${soloActivas}`);

export const validarMoneda = (idMoneda) => api.obtener(`/monedas/${idMoneda}/validacion`);

export const consultarUsoDeMoneda = (idMoneda) => api.obtener(`/monedas/${idMoneda}/uso`);

/** Al reactivar NO se envia confirmado: el servidor lo ignora si llega (RN-041, RN-042). */
export const cambiarEstadoDeMoneda = (idMoneda, activo, { confirmado = false, version } = {}) =>
  api.actualizar(`/monedas/${idMoneda}/estado`, activo ? { activo, version } : { activo, confirmado, version });

// --- Categorias --------------------------------------------------------------

export const consultarCategorias = ({ tipo, soloActivas = true } = {}) =>
  api.obtener(`/categorias?soloActivas=${soloActivas}${tipo ? `&tipo=${tipo}` : ''}`);

export const validarCategoria = (idCategoria, tipoEsperado) =>
  api.obtener(`/categorias/${idCategoria}/validacion${tipoEsperado ? `?tipoEsperado=${tipoEsperado}` : ''}`);

export const consultarUsoDeCategoria = (idCategoria) => api.obtener(`/categorias/${idCategoria}/uso`);

export const crearCategoria = (peticion) => api.publicar('/categorias', peticion);

export const actualizarCategoria = (idCategoria, peticion) =>
  api.actualizar(`/categorias/${idCategoria}`, peticion);

/** Sin confirmado=true el servidor responde CONFIRMACION_REQUERIDA (RN-037). */
export const desactivarCategoria = (idCategoria, { confirmado = false, version } = {}) =>
  api.eliminar(`/categorias/${idCategoria}?confirmado=${confirmado}${version !== undefined ? `&version=${version}` : ''}`);

/** Reactivar: inmediato, sin diálogo de confirmación (RN-011, RN-042). */
export const reactivarCategoria = (idCategoria, version) =>
  api.actualizar(`/categorias/${idCategoria}/estado`, { activo: true, version });

export const reordenarCategorias = (idsEnOrden) =>
  api.actualizar('/categorias/orden', { idsEnOrden });

// --- Periodos ----------------------------------------------------------------

export const resolverPeriodo = (fecha) => api.obtener(`/periodos/resolver?fecha=${fecha}`);

export const consultarPeriodos = ({ desde, hasta, fechaLocal } = {}) => {
  const parametros = new URLSearchParams();
  if (desde) parametros.set('desde', desde);
  if (hasta) parametros.set('hasta', hasta);
  if (fechaLocal) parametros.set('fechaLocal', fechaLocal);
  return api.obtener(`/periodos?${parametros.toString()}`);
};

// --- Usuarios ----------------------------------------------------------------

export const consultarUsuariosDelHogar = (soloActivos = false) =>
  api.obtener(`/usuarios?soloActivos=${soloActivos}`);

export const crearUsuarioDelHogar = (peticion) => api.publicar('/usuarios', peticion);

export const actualizarUsuarioDelHogar = (idUsuario, peticion) =>
  api.actualizar(`/usuarios/${idUsuario}`, peticion);

/** Única vía para cambiar la moneda predeterminada propia (RN-038). Sin tema (D-08). */
export const guardarPreferenciasPropias = (idMonedaPredeterminada) =>
  api.actualizar('/usuarios/yo/preferencias', { idMonedaPredeterminada });

export const cambiarContrasenaPropia = (contrasenaAnterior, contrasenaNueva) =>
  api.actualizar('/usuarios/yo/contrasena', { contrasenaAnterior, contrasenaNueva });

export const restablecerContrasenaDeOtroUsuario = (idUsuario, contrasenaNueva) =>
  api.publicar(`/usuarios/${idUsuario}/contrasena/restablecer`, { contrasenaNueva });

/** Desactivar cierra sus sesiones al instante en todos sus dispositivos (D-09). */
export const cambiarEstadoDeUsuario = (idUsuario, activo, version) =>
  api.actualizar(`/usuarios/${idUsuario}/estado`, { activo, version });

// --- Catálogos ---------------------------------------------------------------

export const obtenerVersionCatalogo = () => api.obtener('/catalogos/version');

export const obtenerEstadoDelServicio = () => api.obtener('/estado');
